export const appDefaults = {
  currency: 'ZAR',
  taxYear: '2027',
  siteName: 'ClearRand',
}

export const fuelDefaults = {
  defaultFuelPrice: 22.0,
  dataDate: '2026-09-01',
  sourceName: 'Department of Mineral Resources and Energy (DMRE) official fuel price publication',
  sourceUrl: 'http://www.energy.gov.za/files/esources/petroleum/petroleum_arch.html',
}

export const vatDefaults = {
  rate: 0.15,
  dataDate: '2026-09-01',
  sourceName: 'SARS VAT rate',
  sourceUrl: 'https://www.sars.gov.za/tax-types/value-added-tax/',
}

export const transferDutyDefaults = {
  brackets: [
    { min: 0, max: 1_210_000, base: 0, rate: 0 },
    { min: 1_210_001, max: 1_663_800, base: 0, rate: 0.03 },
    { min: 1_663_801, max: 2_329_300, base: 13_614, rate: 0.06 },
    { min: 2_329_301, max: 2_994_800, base: 53_544, rate: 0.08 },
    { min: 2_994_801, max: 13_310_000, base: 106_784, rate: 0.11 },
    { min: 13_310_001, max: null, base: 1_241_456, rate: 0.13 },
  ],
  dataDate: '2026-09-18',
  sourceName: 'SARS Transfer Duty Tables',
  sourceUrl: 'https://www.sars.gov.za/tax-types/transfer-duty/',
}
